<template>
	<el-upload :action="'#'" :http-request="onFileUpload" :accept="fileTypes == null ? '' : fileTypes.join(',')"
		:show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="true">
		<slot></slot>
	</el-upload>
</template>

<script>
import { uploadToQiniu } from '@/api/upload'

export default {
	name: "fileUpload",
	data() {
		return {
			loading: null
		}
	},
	props: {
		fileType: {
			type: String,
			default: 'file'
		},
		thumbSize: {
			type: Number,
			default: 20
		},
		fileTypes: {
			type: Array,
			default: null
		},
		maxSize: {
			type: Number,
			default: null
		},
		showLoading: {
			type: Boolean,
			default: false
		},
		isPermanent: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		async onFileUpload({ file }) {
			if (this.showLoading) {
				this.loading = this.$loading({
					lock: true,
					text: this.$t('common.uploading'),
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})
			}
			try {
				const { url } = await uploadToQiniu(file, this.fileType)
				let data
				if (this.fileType === 'image') {
					data = {
						originUrl: url,
						thumbUrl: url + '?imageView2/2/w/' + (this.thumbSize * 10)
					}
				} else if (this.fileType === 'video') {
					data = {
						videoUrl: url,
						coverUrl: url + '?vframe/jpg/offset/1/w/480'
					}
				} else {
					data = url
				}
				this.$emit('success', data, file)
			} catch (e) {
				this.$emit('fail', e, file)
			} finally {
				this.loading && this.loading.close()
			}
		},
		beforeUpload(file) {
			if (this.fileTypes && this.fileTypes.length > 0) {
				const t = this.fileTypes.find((t) => t.toLowerCase() === file.type)
				if (t === undefined) {
					this.$message.error(this.$t('common.fileFormatError', { formats: this.fileTypes.join(', ') }))
					return false
				}
			}
			if (this.maxSize && file.size > this.maxSize) {
				this.$message.error(this.$t('common.fileSizeExceed', { size: this.fileSizeStr }))
				return false
			}
			this.$emit('before', file)
			return true
		}
	},
	computed: {
		fileSizeStr() {
			if (this.maxSize > 1024 * 1024) {
				return Math.round(this.maxSize / 1024 / 1024) + 'M'
			}
			if (this.maxSize > 1024) {
				return Math.round(this.maxSize / 1024) + 'KB'
			}
			return this.maxSize + 'B'
		}
	}
}
</script>

<style></style>
